import {
    UserAdministrationStatus,
    UserAdministrationStatusTypes,
} from "./user-administration-response";

function resolveStatusColor(type) {
    switch (type) {
        case UserAdministrationStatusTypes.INVITED:
            return "grey";
        case UserAdministrationStatusTypes.ACTIVE:
            return "green";
        case UserAdministrationStatusTypes.BLOCKED:
            return "red";
    }
}

const getStatusText = ({ type, text }: UserAdministrationStatus): string => {
    const statusColor = resolveStatusColor(type);
    return `<span class="ux-text-status ux-text-status--${statusColor}"><ux-icon name="circle-filled"></ux-icon>${text}</span>`;
};

export default getStatusText;
